import { render, staticRenderFns } from "./RemoteDataTable.vue?vue&type=template&id=2bfe8b2e&"
import script from "./RemoteDataTable.vue?vue&type=script&lang=js&"
export * from "./RemoteDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports